import { render, staticRenderFns } from "./ClientCustomFieldsForm.vue?vue&type=template&id=1a0d8610&scoped=true&"
import script from "./ClientCustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./ClientCustomFieldsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientCustomFieldsForm.vue?vue&type=style&index=0&id=1a0d8610&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d8610",
  null
  
)

export default component.exports